export class ValidatorError {
  constructor({ validationErrors, message }) {
    const errors = {}
    if (validationErrors && validationErrors.length) {
      validationErrors
        .filter((v) => v)
        .forEach((err) => {
          errors[err['param']] =
            err['message'] || `${err['param']} field is not a valid`
        })
    }
    return {
      error: true,
      data: errors,
      message: message || 'Validation Failed',
      statusCode: 422,
      isInvalid: true,
    }
  }
}

export function throwFormError(form, err) {
  Object.keys(err?.data || {}).forEach((key) => {
    form.setError(key, {
      message: err?.data[key],
    })
  })
}
